import { render, staticRenderFns } from "./LinkedIn.vue?vue&type=template&id=c52f3f50"
import script from "./LinkedIn.vue?vue&type=script&lang=js"
export * from "./LinkedIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c52f3f50')) {
      api.createRecord('c52f3f50', component.options)
    } else {
      api.reload('c52f3f50', component.options)
    }
    module.hot.accept("./LinkedIn.vue?vue&type=template&id=c52f3f50", function () {
      api.rerender('c52f3f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LinkedIn.vue"
export default component.exports